import { render, staticRenderFns } from "./siteMain.vue?vue&type=template&id=1127d78e&"
import script from "./siteMain.vue?vue&type=script&lang=js&"
export * from "./siteMain.vue?vue&type=script&lang=js&"
import style0 from "./siteMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports